(function($) {
	

    if (window.matchMedia("(max-width: 767px)").matches) {
      // Viewport is less or equal to 700 pixels wide
    } else {
      // Viewport is greater than 700 pixels wide
    }


    $(document).ready(function() {
	   
    });
})(jQuery);
